import Vue from 'vue'
import Router from 'vue-router'
import childrenRouter from './routers.js'
import store from '../store'
import authApi from '@/apiFetch/authentication'
Vue.use(Router)

var routes = [
  {
    path: '/',
    component: () => import('../views/index.vue'),
    children: childrenRouter
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
    meta: {
      headerTitle: '登录',
      noLogin: true
    }
  },
  {
    path: '/complianceManagement',
    component: () => import('../views/complianceManagement/index.vue'),
    children: childrenRouter
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/my/index.vue'),
    meta: {
      headerTitle: '个人中心'
    }
  },
  {
    path: '/h5/share',
    name: 'share',
    component: () => import('../views/share/index.vue'),
    meta: {
      headerTitle: '分享页',
      noLogin: true
    }
  },
  {
    path: '/auth',
    name: 'authentication',
    component: () => import('../views/auth/index.vue'),
    meta: {
      headerTitle: '协议'
    },
    children: [
      {
        path: 'agreement',
        name: 'agreement',
        component: () => import('../views/auth/components/agreement.vue'),
        meta: {
          headerTitle: '协议'
        }
      }
    ]
  }
]

// 3. 创建 router 实例，然后传 `routes` 配置 你还可以传别的配置参数
const router = new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition)
        } else {
          resolve({ x: 0, y: 0 })
        }
      }, 0)
    })
  },
  routes
})
router.beforeEach((to, from, next) => {
  if (from.path !== '/') {
    checkForceAuth()
  }
  // 切换模块, 重新获取权限接口
  if (to.matched[1] && from.matched[1] && to.matched[1].name !== from.matched[1].name) {
    console.log('重新获取权限')
    store.dispatch('getPermissions')
  }
  next()
})

const checkForceAuth = () => {
  authApi.checkForceAuth({ userId: store.state.userId })
    .then(data => {
      store.commit('setShowAuth', data)
    })
    .catch((e) => {
    })
}
export default router
